
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 18.006 18.005\" id=\"icon-magnify\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M18.006,16.115l-1.891,1.891l-4.574-4.573c-1.188,0.81-2.628,1.296-4.177,1.296\r\n\tC3.295,14.729,0,11.434,0,7.364S3.295,0,7.364,0s7.364,3.295,7.364,7.364c0,1.548-0.486,2.989-1.297,4.159L18.006,16.115z\r\n\t M7.364,2.449c-2.719,0-4.915,2.197-4.915,4.916c0,2.701,2.196,4.897,4.915,4.897c2.701,0,4.897-2.197,4.897-4.897\r\n\tC12.262,4.646,10.065,2.449,7.364,2.449z\"/> </symbol>";
module.exports = sprite.add(image, "icon-magnify");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/magnify.svg
 ** module id = 200
 ** module chunks = 24
 **/